import { ChoiceDialogContext } from '@rhg/providers/choice-dialog';
import { useContext } from 'react';

/**
 * Before using this component directly, see if you can use the `RegistrationSimpleDialog` component instead as it provides styling that aligns more directly with our design system.
 */
export default function useChoiceDialog() {
    return useContext(ChoiceDialogContext);
}
